import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/4-ways-to-cut-your-tax-bill-in-retirement",
    component: _cffe3db6,
    name: "4-ways-to-cut-your-tax-bill-in-retirement"
  }, {
    path: "/5-steps-to-financial-freedom-after-divorce",
    component: _cffe3db6,
    name: "5-steps-to-financial-freedom-after-divorce"
  }, {
    path: "/budgeting-for-a-non-budgeter",
    component: _cffe3db6,
    name: "budgeting-for-a-non-budgeter"
  }, {
    path: "/contact-us",
    component: _cffe3db6,
    name: "contact-us"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/how-to-protect-your-small-business-from-a-lawsuit",
    component: _cffe3db6,
    name: "how-to-protect-your-small-business-from-a-lawsuit"
  }, {
    path: "/should-you-combine-your-finances-after-getting-married",
    component: _cffe3db6,
    name: "should-you-combine-your-finances-after-getting-married"
  }, {
    path: "/about-us/0e945a0f-4501-4e95-9f90-f30e61945a7d",
    component: _cffe3db6,
    name: "0e945a0f-4501-4e95-9f90-f30e61945a7d"
  }, {
    path: "/about-us/about-new-york-life",
    component: _cffe3db6,
    name: "about-new-york-life"
  }, {
    path: "/about-us/concerns-of-the-business-owner",
    component: _cffe3db6,
    name: "concerns-of-the-business-owner"
  }, {
    path: "/about-us/interesting-links",
    component: _cffe3db6,
    name: "interesting-links"
  }, {
    path: "/about-us/meet-tim",
    component: _cffe3db6,
    name: "meet-tim"
  }, {
    path: "/account-access/96a311be-2049-4928-83ff-d216a217b8ff",
    component: _cffe3db6,
    name: "96a311be-2049-4928-83ff-d216a217b8ff"
  }, {
    path: "/account-access/e3c37fba-6ea5-448a-b51c-459a1a425188",
    component: _cffe3db6,
    name: "e3c37fba-6ea5-448a-b51c-459a1a425188"
  }, {
    path: "/account-access/feb64882-f999-406b-b223-7b2f4a915f4e",
    component: _cffe3db6,
    name: "feb64882-f999-406b-b223-7b2f4a915f4e"
  }, {
    path: "/products-services/advanced-planning-resources",
    component: _cffe3db6,
    name: "advanced-planning-resources"
  }, {
    path: "/products-services/our-services",
    component: _cffe3db6,
    name: "our-services"
  }, {
    path: "/products-services/products",
    component: _cffe3db6,
    name: "products"
  }, {
    path: "/resources/business-solutions",
    component: _cffe3db6,
    name: "business-solutions"
  }, {
    path: "/resources/calculators",
    component: _cffe3db6,
    name: "calculators"
  }, {
    path: "/resources/life-stages",
    component: _cffe3db6,
    name: "life-stages"
  }, {
    path: "/resources/videos",
    component: _cffe3db6,
    name: "videos"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
